/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import currency from "currency.js";
import {
  FieldErrors,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue,
  UseFormTrigger,
} from "react-hook-form";
import {
  GetRfqs200ResponseBlocksInner,
  SideResponse,
} from "../../../../codegen-api";
import { BaseModal } from "../../../../components/BaseModal";
import Tag from "../../../../components/ConfirmationModal/Tag";
import {
  TEXT_COLORS,
  BACKGROUND_COLORS,
  BORDER_COLORS,
  COLORS,
} from "../../../../constants/design/colors";
import { Button, ButtonThemeEnum } from "../../../../components/Buttons/styles";
import { Input } from "../../../../components/shared/Input";
import { BlockDescWrapper, BlockPriceWrapper } from "./style";
import { SPACING } from "../../../../constants/design/spacing";
import { Spinner } from "../../../../components/shared/Spinner";
import { IRFQFormValues } from "./RequestAcceptRFQModal.types";

interface IRequestAcceptRFQModalFormProps {
  block: GetRfqs200ResponseBlocksInner;
  side: SideResponse;
  show: boolean;
  onHide: () => void;
  isTaker: boolean;
  tags: Array<Array<string | JSX.Element>> | undefined;
  register: UseFormRegister<IRFQFormValues>;
  setValue: UseFormSetValue<IRFQFormValues>;
  trigger: UseFormTrigger<IRFQFormValues>;
  handleSubmit: UseFormHandleSubmit<IRFQFormValues>;
  errors: FieldErrors<IRFQFormValues>;
  legs: IRFQFormValues["legs"];
  onSubmit: () => Promise<void>;
  bestOffer: string | undefined;
  blockPrice: number;
  isLoading: boolean;
  isValid: boolean;
  invertedSide: (s: SideResponse) => SideResponse;
  offerButtonLabel: string;
}

function RequestAcceptRFQModalForm({
  block,
  side,
  show,
  onHide,
  isTaker,
  tags,
  register,
  setValue,
  trigger,
  handleSubmit,
  errors,
  legs,
  onSubmit,
  bestOffer,
  blockPrice,
  isLoading,
  isValid,
  invertedSide,
  offerButtonLabel,
}: IRequestAcceptRFQModalFormProps) {
  return (
    <BaseModal
      style={{
        width: "fit-content",
        minWidth: 311,
      }}
      title={`${isTaker ? "Accept" : "Make"} Offer - ${block.block_id
        .slice(-6)
        .toUpperCase()}`}
      show={show}
      onHide={onHide}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <BlockDescWrapper>
          {block?.legs?.length} instrument(s):
        </BlockDescWrapper>
        <div>
          {tags && (
            <div>
              {tags.map((texts, i) => (
                <div key={i}>
                  <Tag
                    style={{
                      padding: SPACING.two,
                      marginTop: SPACING.three,
                      marginBottom: SPACING.two,
                      border: `1px solid ${BORDER_COLORS.one}`,
                    }}
                    color={TEXT_COLORS.two}
                    backgroundColor={BACKGROUND_COLORS.component}
                    texts={texts}
                  />
                  {!isTaker ? (
                    <Input
                      {...register(`legs.${i}.price`, {
                        onChange: (e) => {
                          const leg = legs[i];
                          leg.price = Number(e.target.value);
                          setValue(`legs.${i}`, leg);
                          trigger(`legs.${i}`);
                        },
                        required: true,
                        validate: {
                          moreThanZero: (v) => v !== undefined && v >= 0,
                        },
                      })}
                      placeholder="0"
                      type="number"
                      error={Boolean(errors.legs?.[i]?.price)}
                    />
                  ) : null}
                </div>
              ))}
            </div>
          )}
        </div>
        <BlockPriceWrapper>
          <span>Block Price:</span>
          <span>
            {currency(
              // eslint-disable-next-line no-nested-ternary
              isTaker ? bestOffer || 0 : blockPrice
            ).format()}
          </span>
        </BlockPriceWrapper>
        <Button
          disabled={isLoading || (isTaker ? false : !isValid)}
          fullWidth
          type="submit"
          buttonTheme={
            (isTaker ? invertedSide(side) : side) === SideResponse.Buy
              ? ButtonThemeEnum.POSITIVE
              : ButtonThemeEnum.NEGATIVE
          }
        >
          {isLoading ? (
            <Spinner
              color={
                (isTaker ? invertedSide(side) : side) === SideResponse.Buy
                  ? COLORS.up.one
                  : COLORS.down.one
              }
            />
          ) : (
            offerButtonLabel
          )}
        </Button>
      </form>
    </BaseModal>
  );
}

export default RequestAcceptRFQModalForm;
